import React from "react";
import { getSegmentListKey, SurveySegment } from '../../../amorg-common';
import { EditableSegmentPanel } from "./EditableSegmentPanel";
import { SegmentationViewMode } from "../../../utils/amorgLocalStorage";


type ReadOnlySegmentPanelProps = {
    segmentLists:SurveySegment[][],
    wrapInCard?:boolean,
    displayAnswerCount?:boolean,
    lockedView?:SegmentationViewMode,
};

export function ReadOnlySegmentPanel (props: ReadOnlySegmentPanelProps): JSX.Element 
{
    const segmentLists = React.useMemo(()=>
        props.segmentLists.map(sl => ({
            segments: sl,
            answerCount:0,
            identifier: getSegmentListKey(sl),
            selected: true
        }))
    , [props.segmentLists]);

    return (
        <>
            <EditableSegmentPanel
                lockedView={props.lockedView}
                segmentLists={segmentLists}
                selection={props.segmentLists}
                displayAnswerCount={props.displayAnswerCount}
                disableEdit
                wrapInCard={props.wrapInCard}
                onSelectionChange={() => { return; }} />
        </>
    );
}